import { UzCombobox } from '@utazzo/ui';

import { usePickerOptions } from './usePickerOptions';

import * as currenciesApi from '@/features/currencies/currencies.api';

interface CurrencyPickerProps {
  label?: string;
  value: string | null;
  onValueChange: (value: string | null) => void;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  hint?: string;
}

export const CurrencyPicker = ({
  label = 'Currency',
  value,
  onValueChange,
  required,
  disabled,
  error,
  hint,
}: CurrencyPickerProps): React.JSX.Element => {
  const { options, loading, setSearch } = usePickerOptions(
    {
      cacheKey: 'picker.currencies',
      fetch: async (search) => {
        const res = await currenciesApi.listCurrencies({
          page: 1,
          pageSize: 50,
          sortDir: 'asc',
          ...(search ? { search } : {}),
        });
        return res.data;
      },
      fetchOne: async (id) => {
        try {
          return await currenciesApi.getCurrency(id);
        } catch {
          return null;
        }
      },
      toOption: (c) => ({
        value: c.id,
        label: `${c.code} - ${c.name}`,
        description: c.symbol ?? undefined,
      }),
    },
    value,
  );

  return (
    <UzCombobox
      label={label}
      placeholder="Select a currency"
      searchPlaceholder="Search currencies..."
      value={value ?? ''}
      onValueChange={(v) => onValueChange(v || null)}
      onSearchChange={setSearch}
      options={options}
      loading={loading}
      required={required}
      disabled={disabled}
      error={error}
      hint={hint}
    />
  );
};
